const defaultCSS = `
  @import url('https://fonts.googleapis.com/css2?family=Alata&display=swap');

  * {
      touch-action: manipulation;
      user-select: none;
      -moz-user-select: none;
      -webkit-user-select: none;
      -webkit-touch-callout: none;
      -webkit-text-size-adjust: none;
  }

  html, body {
      overflow: hidden;
      width: 100vw;
      height: 100vh;
      margin: 0;
      padding: 0;
      font-family: "Alata", sans-serif;
      font-weight: 400;
      color: #746F8E;
      background: #ECF9DE;
      font-size: 90%;
  }

  canvas {
      width: 100vw;
      height: 100vh;
  }

  h1 {
      font-size: 3.25rem; /* 3.75rem = 60px @ 16px base */
      line-height: 4.0rem; /* 4rem = 64px @ 16px base */
      font-weight: 400; /* headings not bold */
      margin: 0;
  }

  h2 {
      font-size: 2.0rem; /* 3rem = 48px @ 16px base */
      line-height: 3.0rem; /* 3.5rem = 56px @ 16px base */
      font-weight: 400; /* headings not bold */
      margin: 0;
  }

  .cover-all {
      position: absolute;
      overflow: hidden;
      width: 100vw;
      height: 100vh;
      margin: 0;
      padding: 0;
      font-size: 1.5rem;
      line-height: 2.25rem;
  }

  .box-outline svg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      padding: 0;
      margin: 0;
  }

  a, a:link, a:visited, a:hover, a:active {
      color: #E0C976;
  }

  div.cover-all .box-content {
      display: none;
      position: absolute;

      top: 25vh;
      left: 30vw;
      width: 40vw;
      height: 50vh;
      margin: 0 25vw 30vh 20px;
      vertical-align: top;
      overflow: scroll;
      scrollbar-color: #E0C976 #E0C976;
  }

  #artwork {
      z-index: 50;
  }

  #root {
      z-index: 100;
      position: absolute;
      width: 100vw;
  }

  .icon > div {
      width: 10vh;
      height: 10vh;
      max-width: 80px;
      max-height: 80px;
      margin: 0;
      cursor: pointer;
  }

  .icon > div svg {
      fill-opacity: 0.6;
  }

  .icon > div:nth-child(2) {
      display: none;
  }

  @media only screen and (max-device-width: 1336px) {

      div.cover-all div.box-content p {
          font-size: 1.15rem;
          line-height: 1.5rem;
      }

      @media (orientation: landscape) {
          .icon > div {
              width: 10vh;
              height: 10vh;
          }

          h1 {
              font-size: 1.5rem; /* 3.75rem = 60px @ 16px base */
              line-height: 2rem; /* 4rem = 64px @ 16px base */
          }

          h2 {
              font-size: 1.33rem; /* 3rem = 48px @ 16px base */
              line-height: 1.75rem; /* 3.5rem = 56px @ 16px base */
          }

          div.cover-all .box-content {
              top: 30vh !important;
              height: 50vh !important;
          }
      }
      @media (orientation: portrait) {
          .icon > div {
              width: 10vw;
              height: 10vw;
              margin: 0;
              cursor: pointer;
          }

          h1 {
              font-size: 1.75rem; /* 3.75rem = 60px @ 16px base */
              line-height: 2.25rem; /* 4rem = 64px @ 16px base */
          }

          h2 {
              font-size: 1.5rem; /* 3rem = 48px @ 16px base */
              line-height: 2.0rem; /* 3.5rem = 56px @ 16px base */
          }

          div.cover-all .box-content {
              top: 18vh !important;
              height: 45vh !important;
          }
      }
  }
`;

export default defaultCSS;
